import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { List } from 'immutable';

import classNames from 'classnames';

import { sum } from '../../helpers/Immutable';
import { translate as t } from '../../lib/I18n';
import PassengersForm from '../../records/search/PassengersForm';

import Icon from '../general/Icon';
import PassengersModal from './PassengersModal';
import SectionErrors from './SectionErrors';
import PureRenderComponent from '../PureRenderComponent';

import connectToStores from '../../helpers/connectToStores';
import UserStore from '../../stores/UserStore';
import RailcardsStore from '../../stores/RailcardsStore';
import RailcardsActions from '../../actions/RailcardsActions';
import PassengerRailcard from '../../records/PassengerRailcard';

import FeatureFlagStore from '../../stores/FeatureFlagStore';


const _getStateFromStores = () => {
    return {
        favouriteDRC: RailcardsStore.getFavouriteDRC(),
        user: UserStore.getCurrent()
    };
};


class PassengersSummary extends PureRenderComponent {

    static propTypes = {
        adults: PropTypes.number.isRequired,
        children: PropTypes.number.isRequired,
        railcards: PropTypes.instanceOf(List),
        onChange: PropTypes.func,
        Form: PropTypes.func,
        hideRailcards: PropTypes.bool,
    };

    static defaultProps = {
        railcards: null,
        onChange: _.noop,
        Form: PassengersForm,
        hideRailcards: false
    };

    state = {
        modalOpen: false
    };

    componentDidMount = () => {
        const enableDigitalRailcards = FeatureFlagStore.get('enableDigitalRailcards');

        if (enableDigitalRailcards) {
            this._preselectDRC(this.props, {});
        }
    }

    componentDidUpdate = (prevProps) => {
        const enableDigitalRailcards = FeatureFlagStore.get('enableDigitalRailcards');

        if (enableDigitalRailcards) {
            this._preselectDRC(this.props, prevProps);
        }
    }

    _preselectDRC = (currentProps, prevProps) => {
        const enableDigitalRailcards = FeatureFlagStore.get('enableDigitalRailcards');

        const { user, favouriteDRC, railcards } = currentProps;
        const hasJustLoggedIn = !(prevProps.user && prevProps.user.id) && user.id;

        if (enableDigitalRailcards && hasJustLoggedIn) {
            _.defer(() => RailcardsActions.loadAccountDRC(user.id));
        }

        const isRailcardNotSelected = railcards.size === 0;
        const hasJustFetchedFavourite = favouriteDRC && ((prevProps.favouriteDRC && prevProps.favouriteDRC.id) || null) !== favouriteDRC.id;

        if (hasJustFetchedFavourite && isRailcardNotSelected) {
            this._setFavouriteDRC(favouriteDRC);
        }
    }

    _setFavouriteDRC = ({ railcardCode: code }) => {
        const { onChange, adults, children } = this.props;
        const railcard = new PassengerRailcard({ quantity: 1, code });

        _.defer(() => onChange(adults, children, new List([railcard])));
    }

    _toggleModal = () => {
        this.setState({ modalOpen: !this.state.modalOpen });
    };

    _handleChange = (adults, children, railcards) => {
        this._toggleModal();
        this.props.onChange(adults, children, railcards);
    };

    _renderModal () {
        if (!this.state.modalOpen) {
            return null;
        }

        return (
            <PassengersModal
                show={ this.state.modalOpen }
                adults={ this.props.adults }
                children={ this.props.children }
                railcards={ this.props.railcards }
                onCancel={ this._toggleModal }
                onSelect={ this._handleChange }
                Form={ this.props.Form }
                hideRailcards={ this.props.hideRailcards }
                hideFareInfo={ this.props.hideFareInfo }
            />
        );
    }

    _validate () {
        const { railcards, adults, children } = this.props;
        const form = new this.props.Form({ railcards, adults, children });
        const errors = form.getValidationSummaryArray();
        return errors;
    }

    _renderErrors () {
        const errors = this._validate();
        return errors.length > 0 ? <SectionErrors errors={ errors } /> : null;
    }

    render () {
        const { adults, children, hideRailcards, railcards } = this.props;

        let railcardsText = '';
        
        if (railcards && !hideRailcards) {
            railcardsText = ' - ' + t('booking.railcards.summary', { railcards: sum(railcards, 'quantity') });
        }

        return (
            <section className="booking__section passengers">
                { this._renderModal() }

                <button ref="button" className="btn-box" type="button" onClick={ this._toggleModal }>
                    { t('booking.passengers.summary.text', { adults, children }) }
                    { railcardsText + ' ' }
                    <Icon
                        className={classNames('pull-right', 'box__icon', 'icon-top-right-absolute', { hideRailcards })}
                        icon="passengers"
                        srOnly={t('ariaLabel.passengerInfo')}
                    />
                </button>

                { this._renderErrors() }
            </section>
        );
    }
}

export default connectToStores([RailcardsStore, UserStore], _getStateFromStores)(PassengersSummary);



// WEBPACK FOOTER //
// ./src/components/search/PassengersSummary.js